// QA Server URL
// const serverURL = "https://vtestapi-qa.vthinkglobal.com/api";
// Production Server URL
const serverURL = "https://vtestapi.vthinkdeveloper.com/api";
// Local Server URL
// const serverURL = "http://localhost:5050/api";

export default serverURL;
